// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610220735/js/" + chunkId + "." + {"44":"d3ffa772","225":"d5b0e712","481":"23c22c82","486":"56462cd2","770":"e77e10f8"}[chunkId] + ".0.5714278880718697.chunk.js";
};